module.exports = __webpack_public_path__ + "img/motor_no22.385c0ee9.jpg";